import { Thumbnail } from '@sparemin/blockhead';
import React from 'react';
import EpisodeListEpisodeDescription from 'blocks/AutomationCMS/components/EpisodeListEpisodeDescription';
import EpisodeListRow from 'blocks/AutomationCMS/components/EpisodeListRow';
import { clipSuggestionNameSelector } from 'blocks/ClipSelect/selectors';
import { getAspectRatioValue } from 'utils/aspect-ratio';
import { headerBlock as block } from '../../utils';
import { useClipSelect } from '../ClipSelectContext';
import HeaderItem from './HeaderItem';

export interface HeaderPodcastInfoProps {}

const HeaderPodcastInfo: React.FC<HeaderPodcastInfoProps> = () => {
  const {
    activeSuggestion,
    suggestionIds,
    updatedSuggestionProjectNames,
    clipsPageInfo: {
      title,
      subtitle,
      artwork,
      mediaDurationMillis,
      publishedAtMillis,
      artworkAspectRatioName,
    },
  } = useClipSelect();

  const clipName = clipSuggestionNameSelector(
    updatedSuggestionProjectNames[activeSuggestion?.id],
    activeSuggestion,
    suggestionIds,
    {
      as: 'string',
    },
  );

  return (
    <HeaderItem disableInteraction>
      <EpisodeListRow
        className={block('podcast-info')}
        active={false}
        style={{ height: 'auto' }}
      >
        <EpisodeListRow.Container
          className={block('podcast-info-container')}
          collapsible
        >
          <EpisodeListRow.Artwork>
            <div className={block('artwork-container')}>
              {activeSuggestion?.videoThumbnailUrl ? (
                <img
                  className={block('artwork')}
                  src={activeSuggestion.videoThumbnailUrl}
                />
              ) : (
                <Thumbnail
                  className={block('artwork')}
                  src={artwork}
                  alt="Clip artwork"
                  ratio={getAspectRatioValue(artworkAspectRatioName)}
                  basis={
                    getAspectRatioValue(artworkAspectRatioName) < 1
                      ? 'height'
                      : 'width'
                  }
                />
              )}
            </div>
          </EpisodeListRow.Artwork>
          {title && (
            <EpisodeListEpisodeDescription
              className={block('podcast-info-description')}
              title={activeSuggestion ? clipName : title}
              subtitle={activeSuggestion ? undefined : subtitle}
              durationMillis={mediaDurationMillis}
              publishedAtMillis={publishedAtMillis}
            />
          )}
        </EpisodeListRow.Container>
      </EpisodeListRow>
    </HeaderItem>
  );
};

export default HeaderPodcastInfo;
